/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Section_Social_LinksInputs */

const en_footer_section_social_links = /** @type {(inputs: Footer_Section_Social_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Links`)
};

const es_footer_section_social_links = /** @type {(inputs: Footer_Section_Social_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redes Sociales`)
};

/**
* | output |
* | --- |
* | "Social Links" |
*
* @param {Footer_Section_Social_LinksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_section_social_links = /** @type {((inputs?: Footer_Section_Social_LinksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Section_Social_LinksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_section_social_links(inputs)
	return en_footer_section_social_links(inputs)
});